/* eslint-disable react/jsx-props-no-spreading */
import { type GoogleMapPinProps, type AssetsIcon } from '../AssetsListingHelpers';
import DuotoneIcon from '2-core-elements/Icon/DuotoneIcon';

interface ItemPinProps extends GoogleMapPinProps {
    icon: AssetsIcon;
    onClick?: () => void;
    isActive?: boolean;
}

type ItemPinSkin = '1' | '2' | '3' | '4' | '5';

export const getSkin = (icon: ItemPinProps['icon']): ItemPinSkin => {
    switch (icon) {
    // case 'water-01':
    // case 'pipeline-02':
    // case 'electricity':
    //     return '2';
    // case 'wind-power-01':
    // case 'gas-01':
    // case 'pipeline-01':
    // case 'solar-power-02':
    // case 'diversity':
    //     return '3';
    // case 'digital':
    // case 'data-01':
    //     return '4';
    // case 'education':
    // case 'healthcare':
    // case 'government':
    // case 'rail':
    //     return '5';
    // airports-01
    // seaport-04
    // road-01
    case 'operation':
        return '2';
        break;
    default: return '1';
    }
};


const ItemPin = ({ onClick, isActive = false, style, icon = 'map' }: ItemPinProps): JSX. Element => {
    const skin = getSkin((icon));

    return (
        <button
            type="button"
            className={`item-pin skin-${skin} ${isActive ? 'is-active' : ''}`}
            onClick={onClick}
            style={style}
            aria-label="Pin location"
        >
            <div className="item-pin-loader">
                <div className="item-pin-loader-anim">
                    <div className="item-pin-loader-item" />
                    <div className="item-pin-loader-item" />
                </div>
            </div>
            <DuotoneIcon icon={icon} />
        </button>
    );
};

export default ItemPin;
